import { TypedUseSelectorHook, useSelector as useSelectorBase } from 'react-redux';
import { AppState } from '~/store';

const useSelector: TypedUseSelectorHook<AppState> = useSelectorBase;

export default useSelector;
